// SemanticUI-free pre-@plone/components
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import { useSelector, shallowEqual } from 'react-redux';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import userIcon from '../../icons/user.svg';
import useroutIcon from '../../icons/logout.svg';

const Anontools = () => {
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const content = useSelector((state) => state.content.data, shallowEqual);
  const iconSize = '18px';
  const { settings } = config;

  return !token ? (
    <div className="anontools">
      <Link
        aria-label="login"
        to={`/login${content?.['@id']
          ? `?return_url=${flattenToAppURL(content['@id'])}`
          : ''
          }`}
      >
        <FormattedMessage id="Log in" defaultMessage="Log in" />
        <Icon
          className='user-icon'
          name={userIcon}
          size={iconSize}
          title='user'
        />
      </Link>
    </div>
  ) : (
    <div className="anontools">
      <Link
        aria-label="logout"
        to={`/logout${content?.['@id']
          ? `?return_url=${flattenToAppURL(content['@id'])}`
          : ''
          }`}
      >
        <FormattedMessage id="Log out" defaultMessage="Log out" />
        <Icon
          className='logout-icon'
          name={useroutIcon}
          size={iconSize}
          title='logout'
        />
      </Link>
    </div>
  )

};

export default Anontools;

Anontools.propTypes = {
  token: PropTypes.string,
  content: PropTypes.shape({
    '@id': PropTypes.string,
  }),
};

Anontools.defaultProps = {
  token: null,
  content: {
    '@id': null,
  },
};
